import * as constants from './const'
let backendHost;
let ssoHost;
let socketHost;
let reportsHost;
let sentryDsn;
let casinoHost;
let imageBasePath;
let masterHost;
let affiliateLink;

const hostname = window && window.location && window.location.hostname;
const currentHost = window && window.location && window.location.origin;

if (hostname.includes(constants.localhost)) {
  backendHost = constants.qaServerApi;
  socketHost = constants.qaSocketEndPoint;
  reportsHost = constants.qaReportsAPI;
  sentryDsn = constants.qaSentryKeyDsn;
  casinoHost = constants.qaCasinoAPI;
  imageBasePath = constants.qaImagePath;
  affiliateLink = constants.qaAffiliateUrl;
  // backendHost = constants.livehostapi;
  // socketHost = constants.liveSocketEndPoint;
  // reportsHost = constants.liveReportsAPI;
  // sentryDsn = constants.liveSentryKeyDsn;
  // casinoHost = constants.liveCasinoAPI;
  // masterHost = constants.liveMasterAPI;
  // imageBasePath = constants.localImagePath;
} else if (hostname.includes(constants.qaServer)) {
  backendHost = constants.qaServerApi;
  socketHost = constants.qaSocketEndPoint;
  reportsHost = constants.qaReportsAPI;
  sentryDsn = constants.qaSentryKeyDsn;
  casinoHost = constants.qaCasinoAPI;
  masterHost = constants.liveMasterAPI;
  affiliateLink = constants.qaAffiliateUrl;
  imageBasePath = constants.qaImagePath;
} else if (hostname.includes(constants.livehost)) {
  backendHost = constants.livehostapi;
  socketHost = constants.liveSocketEndPoint;
  reportsHost = constants.liveReportsAPI;
  sentryDsn = constants.liveSentryKeyDsn;
  casinoHost = constants.liveCasinoAPI;
  masterHost = constants.liveMasterAPI;
  affiliateLink = constants.liveAffiliateUrl;
  imageBasePath = constants.liveImagePath;
}  else {
  backendHost = process.env.REACT_APP_BACKEND_HOST || constants.qaServerApi;
  socketHost = constants.qaSocketEndPoint;
  sentryDsn = constants.qaSentryKeyDsn;
  casinoHost = constants.qaCasinoAPI;
  masterHost = constants.liveMasterAPI;
  affiliateLink = constants.qaAffiliateUrl;
  imageBasePath = constants.qaImagePath;
}

export const API_ROOT = `${backendHost}/`;
export const APP_ROOT = `${currentHost}/`;
export const SSO_ROOT = `${ssoHost}/`;
export const SOCKET_ROOT = `${socketHost}/`;
export const REPORTS_ROOT = `${reportsHost}/`;
export const SENTRY_DSN = `${sentryDsn}`;
export const CASINO_ROOT = `${casinoHost}/`;
export const MASTER_ROOT = `${masterHost}/`;
export const BASE_IMAGE_PATH = `${imageBasePath}`;
export const BASE_IMAGE_PATH_NEW = `${constants.liveImagePathNew}`;
export const AFFILIATE_LINK = `${affiliateLink}/`;